<template>
    <div class="main">
        <div>
            <!-- 顶部banner -->
            <div class="topImg">
                <img src="@/assets/images/toppic3@2x.png" alt="" />
                <div @click="downLoad">
                    <img src="@/assets/images/xiazai@2x.png" alt="" class="xiazai" /> </div
                ><img src="@/assets/images/16@2x.png" alt="" class="cadpa" @click="showPage = true" />
            </div>
            <!-- 宣传动画 -->
            <div class="animaWrap">
                <div class="anima">
                    <video-player class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions">
                    </video-player>
                </div>
                <img src="@/assets/images/gift@2x.png" alt="" @click="handleGoGift" />
            </div>
            <!-- 游戏简介 -->
            <div class="introductionWrap">
                <div class="introduction">
                    <img src="@/assets/images/bianzu.png" alt="" class="pic2" />
                    <div>
                        <h3>游戏简介</h3>
                        <span
                            >危险的敌人正在攻击整个城市，城市已经陷入危机！ <br />
                            被梦境试炼唤起的你，已经成为身负重任的战士！<br />
                            作为一名极具潜力的人类战士，你将与其他幸存者一起拿起武器，战胜危险的敌人！<br />
                            敌人的力量依旧强大，稍不留神就会让自己陷入险境！ <br />
                            在这种艰难时刻，想尽办法，生存下去吧！</span
                        >
                    </div>
                </div>
            </div>
            <!-- 游戏特色 -->
            <div class="featureWrap">
                <div class="feature">
                    <img src="@/assets/images/tese@2x.png" alt="" />
                    <div>
                        <h2>游戏特色</h2>
                        <p>
                            · 1000+怪物同屏，消灭他们！<br />
                            · 单手操作，疯狂割草！ <br />
                            · 全新Rougelike技能体验，无限组合！ <br />
                            · 全新关卡体验，多重难度选择！
                        </p>
                    </div>
                </div>
            </div>
            <!-- 游戏截图 -->
            <div class="screenshotWrap">
                <div class="screenshot">
                    <img src="@/assets/images/pic5@2x.png" alt="" />
                    <img src="@/assets/images/1024_habby@2x.png" alt="" class="logo" />
                </div>
            </div>
            <!-- 联系我们 -->
            <div class="connectWrap">
                <h3>联系我们</h3>
                <div class="channelWrap">
                    <div class="hover">
                        <div class="model"><img src="@/assets/images/gongzhonghao.jpg" alt="" /></div>
                        <img src="@/assets/images/wechat@2x.png" alt="" />
                        <span>官方公众号</span>
                    </div>
                    <div>
                        <a href="https://weibo.com/u/7768234867"> <img src="@/assets/images/vlog@2x.png" alt="" /></a>
                        <span>官方微博</span>
                    </div>
                    <div class="hover">
                        <div class="modelText">
                            <!-- <p>官方QQ1群：556881938</p>
                            <p>官方QQ2群：760854546</p>
                            <p>官方QQ3群：200545216</p> -->
                            <p>官方QQ群：516996086</p>
                            <p>官方QQ群：761681827</p>
                        </div>
                        <img src="@/assets/images/qq@2x.png" alt="" />
                        <span>官方QQ群</span>
                    </div>
                </div>
            </div>
            <!-- footer  -->
            <footer>
                <img src="@/assets/images/habby@2x.png" alt="" />
                <div>
                    抵制不良游戏 拒绝盗版游戏 注意自我保护 谨防受骗上当
                    <p></p>
                    适度游戏益脑 沉迷游戏伤身 合理安排时间 享受健康生活
                </div>
                <div>
                    适龄提示：适合8岁（含）以上玩家娱乐
                    <p></p>
                    Copyright@2021-2022 HabbyGames all rights reserved
                    <p></p>

                    审批文号：国新出审[2020]1376号
                    <p></p>
                    出版物号：ISBN 978-7-498-07853-7
                    <p></p>
                    出品单位：上海乐钻科技有限公司
                    <p></p>
                    联系电话：021-80270689
                </div>
                <div>
                    <a href="https://www.lezuan.net/server.html">游戏许可及服务协议</a> ｜<a
                        href="http://www.lezuan.net/termsOfSubscription.html"
                        >游戏隐私保护指引</a
                    >
                </div>
                <div>
                    京ICP备19032146号-1
                </div>
            </footer>
        </div>
        <div class="showPageWrap" v-show="showPage">
            <ChildrenPage @handleCloseAgreement="showPage = false"></ChildrenPage>
        </div>
    </div>
</template>

<script>
import { myHTTP } from '@/utils/net'
import queryString from 'query-string'
import { videoPlayer } from 'vue-video-player'
import 'video.js/dist/video-js.css'
import ChildrenPage from '@/components/children.vue'
import { urls } from '@/tool/url'

const parsed = queryString.parse(location.search || '') || {}
export default {
    components: {
        videoPlayer,
        ChildrenPage
    },
    data() {
        return {
            showPage: false,
            playerOptions: {
                playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
                autoplay: false, // 如果为true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 是否视频一结束就重新开始。
                preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: 'zh-CN',
                aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [
                    {
                        type: 'video/mp4', // 类型
                        src: 'https://danke.habby.cn/mp4/ver.mp4' // url地址
                    }
                ],
                poster: '', // 封面地址
                notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                    timeDivider: true, // 当前时间和持续时间的分隔符
                    durationDisplay: true, // 显示持续时间
                    remainingTimeDisplay: false, // 是否显示剩余时间功能
                    fullscreenToggle: true // 是否显示全屏按钮
                }
            }
        }
    },
    methods: {
        downLoad(){
            if ((navigator.userAgent.indexOf('iPhone') != -1)) {
                window.location.href = urls.ios
            } else {
                window.location.href = urls.and
            }
        },
        handleGoGift() {
            let myPlayer = this.$refs.videoPlayer.player
            myPlayer.pause()
            this.$emit('handleGift')
        }
    }
}
</script>

<style scoped lang="less">
.main {
    width: 100%;
    overflow: hidden;
    position: relative;
    // font-family: 'CookieRunBold';
    font-weight: 600;
    .body {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.42);
    }
    // 顶部banner
    .topImg {
        text-align: center;
        overflow: hidden;
        position: relative;
        img {
            // height: 19.375rem;
            width: 100%;
        }
        .xiazai {
            width: 22.5rem;
            position: absolute;
            bottom: 2.75rem;
            left: 50%;
            transform: translateX(-50%);
        }
        .cadpa {
            width: 8.125rem;
            position: absolute;
            top: 2.625rem;
            right: 2.3125rem;
        }
    }
    //  宣传动画
    .animaWrap {
        background: linear-gradient(180deg, #000000 0%, #4c1c01 100%);
        padding: 2.5rem 0;
        text-align: center;
        .anima {
            margin: 0 auto;
            width: 38.5rem;
            min-height: 68.125rem;
        }
        /deep/video {
            height: auto !important;
        }
        /deep/.vjs_video_417.vjs-fluid {
            padding-top: 60%;
        }

        img {
            width: 38.0625rem;
        }
    }
    // 游戏简介
    .introductionWrap {
        background: url('~@/assets/images/wen2@2x.png') 100% 100% no-repeat;
        background-size: 100% 100%;
        // height: 37.5rem;
        padding: 11.25rem 0;
        .introduction {
            margin: 0 auto;
            display: inline-block;
            .pic2 {
                width: 22.8125rem;
            }
            div {
                text-align: left;
                display: inline-block;
                padding: 0 5.25rem;
                h3 {
                    font-size: 3.125rem;
                    margin: 2.5rem 0;
                }
                font-size: 1.875rem;
                line-height: 1.5;
            }
        }
    }
    // 游戏特色
    .featureWrap {
        .feature {
            position: relative;
            img {
                width: 100%;
            }
            div {
                width: 100%;
                text-align: center;
                position: absolute;
                top: 8.125rem;
                left: 50%;
                transform: translateX(-50%);
                color: #fff;
                h2 {
                    font-size: 3.125rem;
                    margin-bottom: 2.5rem;
                    font-weight: 600;
                }
                font-size: 1.875rem;
                line-height: 1.5;
            }
        }
    }
    // 游戏截图
    .screenshotWrap {
        .screenshot {
            position: relative;
            padding: 8.25rem 0 13.5625rem;
            background: #f6f6fb;
            img {
                width: 42.75rem;
            }
            .logo {
                width: 12.5rem;
                position: absolute;
                bottom: -6.25rem;
                left: 50%;
                transform: translateX(-50%);
            }
        }
    }
    // 联系我们
    .connectWrap {
        padding: 11.25rem 0 7.5rem;
        h3 {
            font-size: 2.25rem;
            line-height: 3.125rem;
        }
        .channelWrap {
            margin-top: 3.125rem;
            div {
                display: inline-block;
                text-align: center;
                img {
                    margin: 0 auto;
                    display: block;
                    width: 5rem;
                    margin-bottom: 1.875rem;
                }
                span {
                    margin-top: 1.875rem;
                }
            }
            div:nth-child(2) {
                margin: 0 3.75rem;
            }
        }
        .hover {
            position: relative;
            .model {
                display: none;
            }
            .modelText {
                display: none;
            }
        }
        .hover:hover {
            .model {
                display: block;
                position: absolute;
                left: -20%;
                top: -120%;
                img {
                    width: 11rem;
                }
            }
            .modelText {
                position: absolute;
                left: -100%;
                top: -94%;
                font-size: 1rem;
                display: inline-block;
                padding: 2rem;
                background: #b3b3b3;
                min-width: 180px;
                border-radius: 1.25rem;
                p {
                    display: inline-block;
                }
            }
        }
    }

    // footer
    footer {
        padding: 4.375rem 0 2.9375rem;
        background: #000000;
        color: #757575;
        font-size: 1rem;
        img {
            width: 18.75rem;
        }
        a {
            color: #b3b3b3;
        }
        div {
            margin-top: 1.875rem;
        }
        p {
            height: 0.8rem;
        }
    }
    .showPageWrap {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.42);
        // pointer-events: none; //不能操作
    }
}
</style>


// WEBPACK FOOTER //
// src/components/mobile.vue